import { createSlice } from "@reduxjs/toolkit";
import { createEncryptedAsyncThunk } from "../../Utility/APIUtils";
import _ from "lodash";
import { consoleEnableKey } from "../../../components/common/constant";

const initialState = {
  // creditAmount
  creditAmountSucess: false,
  creditAmountResponse: {
    error: false,
    message: "",
  },
  commonDeleteResponse: {
    status: false,
    message: "",
  },
  commonDeleteSucces: false,
  error: "",
  loading: false,
};

export const getNotification = createEncryptedAsyncThunk(
  "managementSlice/getNotification",
  "account/GetNotificationDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      roles: [1, 2, 3, 4, 5, 6],
      serviceId: [],
      city: [],
      states: '',
      platform: [],
      startDate: null,
      endDate: null,
      notification_type: ''
    }),
  }
);
export const CreateNotification = createEncryptedAsyncThunk(
  "managementSlice/CreateNotification",
  "account/CreateNotification",
  {
    prepareBody: (params) => ({
      userId: params.body.currentUser.userGuid,
      language: params.body.languageId,
      platform: params.body.platformId,
      role: params.body.roleId,
      services: params.body.servicesId,
      state: params.body.stateId,
      city: params.body.cityId,
      start_Date: params.body.fromDate,
      end_Date: params.body.toDate,
      images: [params.body.image],
      description: params.body.description,
      notification_type: ''
    }),
  }
);
export const addBanner = createEncryptedAsyncThunk(
  "managementSlice/addBanner",
  "account/addBanner",
  {
    prepareBody: (params) => ({
      userId: params.body.currentUser.userId,
      language: params.body.languageId,
    }),
  }
);

// export const getLoginHistory = createEncryptedAsyncThunk(
//   'managementSlice/getLoginHistory',
//   (params)=> `account/GetUserLoginLogs?userId=${
//     params.currentUser.userId
//   }&userLogId=${1}`,
//   {
//    method: 'GET'
//   },
// );
export const getLoginHistory = createEncryptedAsyncThunk(
  "managementSlice/getLoginHistory",
  "account/GetUserLoginLogs",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      userLogId: params.selectDistributor ? params.selectDistributor.value : 0,
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
      ipAddress: "",
    }),
  }
);
export const getUserCredentialDetails = createEncryptedAsyncThunk(
  "managementSlice/getUserCredentialDetails",
  "UserRegistration/Get_User_Management",
  {
    prepareBody: (params) => ({
      userId: 0,
      roleId: params.body.roleID.value,
      flag: params.body.roleID.label,
    }),
  }
);
export const updateUserPassword = createEncryptedAsyncThunk(
  "managementSlice/updateUserPassword",
  "UserRegistration/UpdatePassword",
  {
    prepareBody: (params) => ({
      userID: params.modalData.UserID,
      username: params.userName,
      password: params.userPassword,
      mobileNo: params.modalData.Mobile,
    }),
  }
);
export const updateUserMpin = createEncryptedAsyncThunk(
  "managementSlice/updateUserMpin",
  "UserRegistration/SetMPIN",
  {
    prepareBody: (params) => ({
      userID: params.modalData.UserID,
      mpin: params.userPassword,
    }),
  }
);
export const getRetailerCustomer = createEncryptedAsyncThunk(
  "managementSlice/getRetailerCustomer",
  "UserRegistration/GetAgentWiseCustomer",
  {
    prepareBody: (params) => ({
      userId: params.body.setSelectDistributor.value,
      roleId: 0,
      flag: "string",
    }),
  }
);
export const getDecryptedPassword = createEncryptedAsyncThunk(
  "managementSlice/getDecryptedPassword",
  "UserRegistration/Get_Password",
  {
    prepareBody: (params) => ({
      password: params.pass,
    }),
  }
);
export const getRetailerCustomerBeneficiary = createEncryptedAsyncThunk(
  "managementSlice/getRetailerCustomerBeneficiary",
  "UserRegistration/GetCustomerWiseBeni",
  {
    prepareBody: (params) => ({
      userId: 0,
      roleId: params.body.Cust_ID,
      flag: "string",
    }),
  }
);

export const getComplaintReport = createEncryptedAsyncThunk(
  "managementSlice/getComplaintReport",
  "account/GetTicketMaster",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      ticketUserId: 0,
    }),
  }
);
export const getMenuList = createEncryptedAsyncThunk(
  "managementSlice/getMenuList",
  "Roles/GetUserRoleRightStatus",
  {
    prepareBody: (params) => ({
      userId: params.selectedBusiness.value,
      roleId: params.roleId,
    }),
  }
);
export const getUserwiseServiceList = createEncryptedAsyncThunk(
  "managementSlice/getUserwiseServiceList",
  "Service/GetUserServiceMaster",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      service_userId: params.selectedUser.value,
    }),
  }
);
export const getUserMasterData = createEncryptedAsyncThunk(
  'UserManagement/getUserMasterData',
  'Service/GetUserMasterData',
  {
    prepareBody: (params) => ({
      userId: params.selectedUser.userguid,
      key: params.key,
    }),
  },
);
export const updateUserMasterData = createEncryptedAsyncThunk(
  'UserManagement/updateUserMasterData',
  'Service/UpdateUserMasterData',
  {
    prepareBody: (params) => ({
      userId: params.currentUser.userGuid,
      updateAll: params.updateAll || false,
      updateMasterkey: params.updateMasterkey || '',
      keyDatas: params.keyDatas || [],
    }),
  },
);
export const updateUserServiceRights = createEncryptedAsyncThunk(
  "managementSlice/updateUserServiceRights",
  "Service/UpdateUserServiceMaster",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceDetails: params.UpdatedServiceList,
    }),
  }
);

export const CreateUserServiceMaster = createEncryptedAsyncThunk(
  "managementSlice/CreateUserServiceMaster",
  "Service/CreateUserServiceMaster",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceId: Array.isArray(params.serviceId)
        ? params.serviceId
        : [_.toNumber(params.serviceId) || 0],
      accessUserID: Array.isArray(params.accessUserID)
        ? params.accessUserID
        : [_.toNumber(params.accessUserID) || 0],
      role: params.role || 0,
      alluser: params.alluser || false
    }),
  }
);


export const getAPIName = createEncryptedAsyncThunk(
  "managementSlice/getAPIName",
  "Service/GetAPIMaster",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      api_id: 0,
    }),
  }
);

export const transactionByApiRetailer = createEncryptedAsyncThunk(
  "managementSlice/transactionByApiRetailer",
  "Service/GetAPIWiseRetailerTransaction",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      api_id: Number(params.selectedApiName),
      todayDate:params.fromDate,
    }),
  }
);

export const getAPIKeyDetails = createEncryptedAsyncThunk(
  "managementSlice/getAPIKeyDetails",
  "Service/GetAPIKeyDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      api_id: params.selectedAPI,
    }),
  }
);

export const getAPIKeyMasterData = createEncryptedAsyncThunk(
  "managementSlice/getAPIKeyMasterData",
  "Service/GetAPIKeyMaster",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      api_id: params.selectedAPI,
    }),
  }
);

export const createAPIKeyMaster = createEncryptedAsyncThunk(
  "managementSlice/createAPIKeyMaster",
  "Service/createAPIKeyMaster",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      api_id: params.selectAPI,
      apiKey:[{
          keyName:params.body.addName,
          remark:""
      }]
    }),
  },
);

export const updateAPIKeyMaster = createEncryptedAsyncThunk(
  "managementSlice/updateAPIKeyMaster",
  "Service/UpdateAPIKeyMaster",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      api_id: params.selectAPI,
      keytobeReplaced: params.body.updateAPIName,
      keytobeReplacedWith: params.data.keyName,
      status:params.value,
      remark:""

    }),
  },
);

export const updateUserRights = createEncryptedAsyncThunk(
  "managementSlice/updateUserRights",
  "account/UpdateUserRoleRightStatus",
  {
    prepareBody: (params) => ({
      user_Id: 9,
      role_rights: params.menuList,
    }),
  }
);
export const complaintReply = createEncryptedAsyncThunk(
  "managementSlice/complaintReply",
  "account/UpdateTicket",
  {
    prepareBody: (params) => ({
      userId: params.modalData.createdBy,
      comp_id: params.modalData.compId,
      category: params.modalData.category,
      type: params.modalData.type,
      mobileNo: params.modalData.mobileNo,
      subject: params.modalData.subject,
      transaction_id: params.modalData.transactionId,
      description: params.reply,
    }),
  }
);
export const getLimitDetailsCustomer = createEncryptedAsyncThunk(
  "managementSlice/getLimitDetailsCustomer",
  "Service/GetUserDetailsByMobNo",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      mobNo: params.customerMobileNumber,
      role: 1,
    }),
  }
);
export const getLimitNameDetailsCustomer = createEncryptedAsyncThunk(
  "managementSlice/getLimitDetailsCustomer",
  "transaction/QuerryRemitter",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceId: params.serviceSelect.value,
      mobile: params.customerMobileNumber,
      bank3_flag: "No",
      txnType: "IMPS",
      longitude: `${params.lng}`,
      latitude: `${params.lat}`,
      // updateLimit: true,
      
    }),
  }
);
export const updateCustomerName = createEncryptedAsyncThunk(
  "managementSlice/updateCustomerName",
  "account/UpdateCustomerData",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userId: params.currentUser.userGuid,
      custId: params.custId,
      custName: params.customerName,
      status: 1,
      resetLimit: params.resetFlag,
      resetAmt: Number(params.customerLimit),
    }),
  }
);

export const updateUserWiseTpin = createEncryptedAsyncThunk(
  "managementSlice/updateUserWiseTpin",
  "account/ChangeTpin",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      tpinUserId: params.userid,
      oldTpin: "",
      newTpin: params.newTpin,
      confirmTpin: params.newTpin,
    }),
  }
);
export const updateCustomerLimitSubmit = createEncryptedAsyncThunk(
  "managementSlice/updateCustomerLimitSubmit",
  "account/UpdateCustomerLimit",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      customer_mobile: params.customerMobileNumber,
      limit: params.selectSetLimitMobileNo,
    }),
  }
);
export const updateCustomerLimitSubmitAll = createEncryptedAsyncThunk(
  "managementSlice/updateCustomerLimitSubmitAll",
  "account/UpdateAllCustomerLimit",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      limit: params.selectSetLimitMobileNo,
    }),
  }
);
export const resetAllUserLimitWithAmount = createEncryptedAsyncThunk(
  "managementSlice/resetAllUserLimitWithAmount",
  "account/UpdateCustomerLimit",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      customer_mobile: params.customerMobileNumber || '',
      updateAll: params.updateAll || false,
      serviceId: params.serviceId || 0,
      limit: params.customerLimit || 0,
    }),
  }
);
export const complaintDelete = createEncryptedAsyncThunk(
  "managementSlice/complaintDelete",
  "UserRegistration/DeleteComplaint",
  {
    prepareBody: (params) => ({
      com_ID: params.item.Com_ID,
      createdby: 0,
      remarks: "string",
    }),
  }
);

export const GetDataActiveDeactive = createEncryptedAsyncThunk(
  "managementSlice/GetDataActiveDeactive",
  "account/GetAppCongfigKeyDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      master_key: params.masterKey,
    }),
  }
);
export const updateUserLienAmountAction = createEncryptedAsyncThunk(
  "managementSlice/updateUserLienAmountAction",
  "Service/UpdateUserLienAmount",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      updateUserId: params.updateUserId,
      lienAmount: params.lienAmount,
    }),
  }
);

export const managementSlice = createSlice({
  name: "managementSlice",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(GetDataActiveDeactive.fulfilled, (state, action) => {
        state.status = 'details';
        if (!_.isEmpty(action.meta) && !_.isEmpty(action.meta.arg) && action.meta.arg.masterKey === consoleEnableKey) {
          let consoleEnable = null
          if (action.payload && !_.isEmpty(action.payload.data)){
            if (_.trim(action.payload.data.master_key) === consoleEnableKey) {
              consoleEnable = action.payload.data
            }
          }
          state.consoleEnable = consoleEnable
        }
      })
  },
  reducers: {
    creditAmountSuccess(state) {
      return { ...state, creditAmountSucess: true };
    },
    creditAmountFailed(state, action) {
      return {
        ...state,
        creditAmountResponse: { error: true, message: action.payload },
      };
    },
    FetchSuccess(state, action) {
      return { ...state, recharge: action.payload.Data[0] };
    },
    FetchFailed(state, action) {
      return {
        ...state,
        rechargeResponse: { status: true, message: action.payload },
      };
    },
    DeleteSuccess(state) {
      return { ...state, loading: false, commonDeleteSucces: true };
    },
    DeleteFailed(state, action) {
      return {
        ...state,
        fetchError: false,
        commonDeleteResponse: { status: true, message: action.payload },
      };
    },
    DeleteInitial(state) {
      return {
        ...state,
        commonDeleteSucces: false,
        commonDeleteResponse: { status: false, message: "" },
      };
    },
  },
});
export const {
  FetchSuccess,
  FetchFailed,
  DeleteSuccess,
  DeleteFailed,
  DeleteInitial,
  creditAmountSuccess,
  creditAmountFailed,
} = managementSlice.actions;
export default managementSlice.reducer;
